// Generate via https://www.lastpass.com/nl/features/password-generator, 20chars, all chars, no symbols
export const cacheBusterHash = 'MYK2uBpmbchORsWzV0IH';
